import React, { useState } from 'react'
import { Typography, TextField, Grid, Button } from '@material-ui/core';
import { useDispatch } from "react-redux";
import { newComment } from "./../../redux/actions/post";
import Comment from "./comment/Comment";

const Comments = ({ post }) => {
    const dispatch = useDispatch();
    const user = JSON.parse(localStorage.getItem("profile"));
    const [newCmnt, setNewCmnt] = useState({ message: "" });

    const handleNewComment = () => {
        dispatch(newComment(post._id, newCmnt));
        setNewCmnt({ message: "" });
    }

    return (
        <>
            <Typography variant="h5">
                Comments
            </Typography>
            <hr></hr>

            {post?.comments?.length === 0 && (
                <Typography variant="h6" align="center">
                    No comments on this post yet !
                </Typography>
            )}

            <Grid container spacing={1} style={{ marginTop: "7px", marginBottom: "10px" }}>
                <Grid item xs={10}>
                    <TextField name="message" disabled={!user && true} label="Write a comment ..." variant="outlined"
                        value={newCmnt.message} onChange={e => setNewCmnt({ ...newCmnt, message: e.target.value })} fullWidth />
                </Grid>
                <Grid item xs={2}>
                    <Button variant="contained" color="primary" fullWidth size="large" onClick={handleNewComment}
                        style={{ height: "55px" }} disabled={!user && true}>Post
                    </Button>
                </Grid>
            </Grid>

            {post?.comments.map((c, i) => (
                <>
                    <Comment key={c._id} comment={c} post={post} />

                    {i !== post.comments.length - 1 && <hr className="divider"></hr>}
                </>
            ))}
        </>
    )
}

export default Comments;